import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';

import 'financing/components/DepositState/DepositState.scss';

const DepositState = ({ depositAmount }) => {
    const contentZoneDepositMessage = ContentZonesService.getContentZone(
        'widget.checkout',
        'widget.checkout.deposit.message'
    );
    const DepositMessage = contentZoneDepositMessage
        ? contentZoneDepositMessage.getValue() || LocaleService.t('FINANCING.DEPOSIT.SUBTITLE')
        : LocaleService.t('FINANCING.DEPOSIT.SUBTITLE');

    return (
        <div className="confirm_deposit--wrapper">
            <div className="confirm_deposit--icon">
                <icon className="icon-Crochet" />
            </div>
            <div className="confirm_deposit--content">
                <p className="confirm_deposit--title is-bold"> {LocaleService.t('FINANCING.DEPOSIT.CONGRATS')}</p>
                <p className="confirm_deposit--subtitle sr-text is-bold">
                    {LocaleService.t('FINANCING.DEPOSIT.TITLE', {
                        amount: depositAmount,
                    })}
                </p>
                <p>{DepositMessage}</p>
            </div>
        </div>
    );
};

DepositState.defaultProps = {
    depositAmount: 500,
};

DepositState.propTypes = {
    depositAmount: PropTypes.number,
};

DepositState.displayName = 'DepositState';

export default DepositState;
